<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="group.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
          <div class="field">
            <label class="font-medium">Сделки</label>
            <crm-deal-multi-select
              [(selectedDeals)]="group.deals"
              [isError]="$any(errors?.deals)"
              appendTo="body"></crm-deal-multi-select>
            <small
              *ngIf="errors?.deals"
              class="p-error">
              {{ errors.deals | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        header="Аудиторы"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="group.userAuditors"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-multi-select
              [(selectedItems)]="group.groupAuditors"
              [options]="userGroups"
              appendTo="body">
            </crm-multi-select>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit"
        class="mt-3">
        <crm-deal-group-history [index]="index"></crm-deal-group-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveDealGroup()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteDealGroup()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
